import { useGetAutonomousSystemPredictions } from './useGetAutonmousSystemPredictions'
import { useGetRequestAttributes, useGetRequestAttributesKeys } from './useGetRequestAttributes'
import { useGetAnnotationInsights, useGetVqaInsights } from './useInsights'
import { useGetUniqueAutonomousSystemIds } from './useInsightsFilterMetadata'
import { useCreateVqaInference, useCreateVqaPrompt, useGetVqaPromptsForProgram } from './useVqa'
import { useGetConfigurationForProgramId } from './useVqaConfiguration'

export const insights = {
  getAnnotationInsights: useGetAnnotationInsights,
  getAutonomousSystemPredictions: useGetAutonomousSystemPredictions,
  getUniqueAttributes: useGetRequestAttributes,
  getUniqueAttributesKeys: useGetRequestAttributesKeys,
  vqa: {
    infer: useCreateVqaInference,
    createPrompt: useCreateVqaPrompt,
    getAllPromptsByProgramId: useGetVqaPromptsForProgram,
    getProgramConfiguration: useGetConfigurationForProgramId,
    getInsights: useGetVqaInsights,
    getUniqueMetadataValues: useGetUniqueAutonomousSystemIds,
  },
}
